import { render, staticRenderFns } from "./ShareWatchList.vue?vue&type=template&id=908db9a4&scoped=true&"
import script from "./ShareWatchList.vue?vue&type=script&lang=ts&"
export * from "./ShareWatchList.vue?vue&type=script&lang=ts&"
import style0 from "./ShareWatchList.vue?vue&type=style&index=0&id=908db9a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "908db9a4",
  null
  
)

export default component.exports